import { render } from "./ReferenceAdd.vue?vue&type=template&id=e5f28200"
import script from "./ReferenceAdd.vue?vue&type=script&setup=true&lang=js"
export * from "./ReferenceAdd.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "/home/runner/work/SeekingSimple-SSUPR-V3/SeekingSimple-SSUPR-V3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/modules/pmo/components/reference/ReferenceAdd.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "e5f28200"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('e5f28200', __exports__)) {
    api.reload('e5f28200', __exports__)
  }
  
  module.hot.accept("./ReferenceAdd.vue?vue&type=template&id=e5f28200", () => {
    api.rerender('e5f28200', render)
  })

}


export default __exports__